@if (currentTask() && currentTimer()) {
  <div class="flex w-full h-[36px] gap-3.5 bg-proffeo-success py-1.5 px-5 justify-center lg:justify-start items-center">
    <button
      (click)="openTimerDialog()"
      class="hover-opacity"
    >
      <proffeo-task-timer
        [mode]="taskTimerMode.topBar"
        [taskTimer]="currentTimer()"
      ></proffeo-task-timer>
    </button>
    <p class="text-proffeo-on-action">|</p>
    <a
      [routerLink]="buildTaskLink()"
      class="flex gap-2 items-center hover-opacity max-w-1/2 lg:grow lg:max-w-[75%] cursor-pointer"
    >
      <p class="text-proffeo-on-action text-sm truncate">
        {{ (currentTask().taskType()?.code ?? '') + (currentTask().taskType() ? '-' : '') + currentTask().taskNumber }}
        -
        {{ currentTask().name }}
      </p>
      <mat-icon
        fontIcon="open_in_new"
        class="icon-sm icon-white"
      />
    </a>
  </div>
}
